import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-w.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-w.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { AppControllerService } from "../../../../../app-controller.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationService } from "../../../view-application.service";
import { ViewApplicationLocationWConstants } from "./view-application-location-w.constants";
import { WayleaveService } from "../../../../../shared/services/modules/wayleave.service";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { MapTools } from "../../../../../map/shared/map.tools";
import { ViewApplicationProfessionalBodiesWConstants } from "../view-application-professional-bodies-w/view-application-professional-bodies-w.constants";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import GeometryUtils from "../../../../../shared/utils/geometry-utils";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
import { take, takeUntil } from "rxjs/operators";
let ViewApplicationLocationWComponent = class ViewApplicationLocationWComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    appController;
    changeDetectorRefs;
    mapTools;
    wayleaveService;
    viewApplicationService;
    active;
    saveBtnPlaceholder = ViewApplicationLocationWConstants.SAVE_BUTTON_PLACEHOLDER;
    locationForm;
    descriptionLabel1 = ViewApplicationLocationWConstants.DESCRIPTION_LABEL_1;
    mapComponent;
    application;
    isMapLoaded = false;
    sketch;
    selectedGraphic = null;
    getSetLocationObservableSubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, appController, changeDetectorRefs, mapTools, wayleaveService, viewApplicationService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.mapTools = mapTools;
        this.wayleaveService = wayleaveService;
        this.viewApplicationService = viewApplicationService;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
        this.changeDetectorRefs.detectChanges();
    }
    handleRouteChange() {
    }
    onBtnSaveClicked() {
        if (this.locationForm.valid) {
            const centroid = this.locationForm.get("centroid").value;
            const polyline = this.locationForm.get("polyline").value;
            const polygon = this.locationForm.get("polygon").value;
            const polylineDto = this.locationForm.get("polylineDto").value;
            const polygonDto = this.locationForm.get("polygonDto").value;
            const params = {
                shape: WktConverterUtils.ConvertArcGISJsonToWkt(centroid),
                wkid: 102100,
                applicationLines: [],
                applicationPolygons: []
            };
            if (polygon !== null) {
                if (polygonDto === null) {
                    const applicationPolygon = {
                        wkid: 102100,
                        shape: WktConverterUtils.ConvertArcGISJsonToWkt(polygon)
                    };
                    params.applicationPolygons.push(applicationPolygon);
                }
                else {
                    polygonDto.shape = WktConverterUtils.ConvertArcGISJsonToWkt(polygon);
                    params.applicationPolygons.push(polygonDto);
                }
            }
            if (polyline !== null) {
                if (polylineDto === null) {
                    const applicationPolyline = {
                        wkid: 102100,
                        shape: WktConverterUtils.ConvertArcGISJsonToWkt(polyline)
                    };
                    params.applicationLines.push(applicationPolyline);
                }
                else {
                    polylineDto.shape = WktConverterUtils.ConvertArcGISJsonToWkt(polyline);
                    params.applicationLines.push(polylineDto);
                }
            }
            this.getSetLocationObservableSubscription =
                this.wayleaveService.getSetLocationObservable(this.application.id, params)
                    .subscribe({ next: appSaveresponse => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        this.getApplication();
                    }, error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationWConstants.STEP_TITLE, error, CRUDOperation.Update);
                    } });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.getApplication();
        this.sketch = this.mapTools.getMapTool("drawTool");
        this.mapTools.expandWidget("drawTool");
        this.sketch.create("polygon");
        this.sketch.on("create", (event) => {
            if (event.state === "complete") {
                this.selectedGraphic = event.graphic;
                this.locationForm.get("selectedGraphic").setValue(this.selectedGraphic);
                if (event.graphic.geometry.type === "point") {
                    this.locationForm.get("centroid").setValue(event.graphic.geometry);
                    this.locationForm.get("polygon").setValue(null);
                    this.locationForm.get("polyline").setValue(null);
                }
                else {
                    const proxyUrl = ApiProxyConstants.URL;
                    const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                    const url = `${proxyUrl}?${gpToolUrl}`;
                    const formData = new FormData();
                    formData.append("f", "json");
                    formData.append("geometryJSON", JSON.stringify(event.graphic.geometry));
                    this.viewApplicationService.getTrueCentroid(url, formData)
                        .pipe(takeUntil(this._destroy$), take(1))
                        .subscribe({
                        next: (trueCentroidResponse) => {
                            this.locationForm.get("centroid").setValue(trueCentroidResponse.results[0].value);
                            if (event.graphic.geometry.type === "polygon") {
                                this.locationForm.get("polygon").setValue(event.graphic.geometry);
                            }
                            else if (event.graphic.geometry.type === "polyline") {
                                this.locationForm.get("polyline").setValue(event.graphic.geometry);
                            }
                        },
                        error: (error) => {
                            this.appController.handleServerErrorMessage(ViewApplicationLocationWConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                        }
                    });
                }
            }
            else if (event.state !== "cancel") {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
        if (this.locationForm.get("selectedGraphic").value !== null) {
            this.selectedGraphic = this.locationForm.get("selectedGraphic").value;
            this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(this.selectedGraphic.geometry)], "Draw Tool Layer");
        }
    }
    getApplication() {
        const params = {
            $expand: `applicationPolygons,applicationLines`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .pipe(takeUntil(this._destroy$), take(1))
            .subscribe({
            next: (response) => this.onGetApplicationCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationProfessionalBodiesWConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("locationForm");
        this.locationForm = form;
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.application = response.value[0];
            const centroidGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.application.shape, 102100);
            const centroid = JsonUtils.fromJSON(centroidGeometryArc);
            const geometries = [];
            this.locationForm.get("centroid").setValue(centroid);
            let showPoint = true;
            if (this.application.applicationPolygons.length > 0) {
                showPoint = false;
                const polygonGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.application.applicationPolygons[0].shape, 102100);
                const polygon = JsonUtils.fromJSON(polygonGeometryArc);
                this.locationForm.get("polygon").setValue(polygon);
                this.locationForm.get("polygonDto").setValue(this.application.applicationPolygons[0]);
                geometries.push(polygon);
            }
            else {
                this.locationForm.get("polygon").setValue(null);
                this.locationForm.get("polygonDto").setValue(null);
            }
            if (this.application.applicationLines.length > 0) {
                showPoint = false;
                const polylineGeometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.application.applicationLines[0].shape, 102100);
                const polyline = JsonUtils.fromJSON(polylineGeometryArc);
                this.locationForm.get("polyline").setValue(polyline);
                this.locationForm.get("polylineDto").setValue(this.application.applicationLines[0]);
                geometries.push(polyline);
            }
            else {
                this.locationForm.get("polyline").setValue(null);
                this.locationForm.get("polylineDto").setValue(null);
            }
            if (showPoint) {
                geometries.push(centroid);
            }
            this.mapComponent.addGeometriesOnMap(geometries, "View application location", true);
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: MapTools },
        { type: WayleaveService },
        { type: ViewApplicationService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationWComponent = __decorate([
    Component({
        selector: "app-view-application-location-w",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationLocationWComponent);
export { ViewApplicationLocationWComponent };
